import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

const configMap = {
  china: {
    dsn: "https://736a5cd66b804949a602b8315da9def7@sentry.gtech.asia/14"
  },
  malaysia: {
    dsn: "https://ff88d96309e94b61accc5acc9769658b@sentry.gtech.asia/42"
  }
};

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: configMap[process.env.country].dsn,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
}
